import { render, staticRenderFns } from "./AccessWalletMnemonic.vue?vue&type=template&id=eb5fb0c6"
import script from "./AccessWalletMnemonic.vue?vue&type=script&lang=js"
export * from "./AccessWalletMnemonic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports